import { Button, Typography } from '@mui/material';
import { EventBus } from '@/shared/utils';
import { AuthEventKeys, AuthEvents } from '../events';
import Confirm from './confirm';
import { Auth } from '@/shared/i18n';
import { FormType } from '../screen/login-screen';

type EmailSentProps = {
  eventBus: EventBus<AuthEvents>;
  email: string;
  dict: Auth;
  setFormType: (value: FormType) => void;
};

function ForgotPasswordOk({ eventBus, email, dict, setFormType }: EmailSentProps) {
  return (
    <section className="flex z-10 flex-col self-center max-w-[600px] px-6 py-8 md:px-16 md:py-12 rounded-xl bg-paper">
      <Confirm
        imgSrc="/assets/images/email-sent.svg"
        title={dict.forgot_password?.email_sent_title || 'Email inviata a'}
        mailfield={true}
        mail={email}
        description={
          dict.forgot_password?.email_sent_description ||
          'Ti abbiamo inviato le istruzioni per resettare la password. Se non trovi la mail controlla nella cartella dello spam.'
        }
        footer={
          <div className="flex flex-col w-full mt-8">
            <Button
              size="large"
              variant="contained"
              color="primary"
              className="w-full max-md:max-w-full"
              onClick={() => setFormType('login')}
            >
              <Typography variant="button-l">
                {dict.forgot_password?.back_to_login || 'Torna al login'}
              </Typography>
            </Button>
            <div className="flex flex-wrap items-center justify-center w-full gap-1 mt-8">
              <small className="font-medium text-gray-400 text-body2">
                {dict.forgot_password?.email_not_received ||
                  "Non hai ricevuto l'email? Attendi qualche minuto e ripeti la procedura."}
              </small>
            </div>
          </div>
        }
      />
    </section>
  );
}

export default ForgotPasswordOk;
